<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">编辑</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">

                <el-form :model="editForm" :rules="rules" ref="editForm">
                    <div>
                        <el-row>
                            <el-col :span="24" class="item">
                                <el-card class="box-card" shadow='never'>
                                    <el-col :span="12" class="item">
                                        <el-form-item label="费用名称"  required prop="name">
                                            <el-input v-model="editForm.name" placeholder="请输入费用名称"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12" class="item">
                                        <el-form-item label="费用"  required prop="price">元/{{chargeTime}}
                                            <el-input type="number" v-model="editForm.price" placeholder="请输入金额"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12" class="item">
                                        <el-form-item label="状态"  required prop="status">
                                            <el-select
                                                v-model="editForm.status"
                                                style="width:100%"
                                                placeholder="请设置状态">
                                                <el-option
                                                    v-for="item in statusValue"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-card>
                            </el-col>
                        </el-row>
                    </div>

                </el-form>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('editForm')">编辑</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode,getChargeTime} from "@/utils/auth";
    export default {
        name: 'Add',
        props:['departmentList'],
        data() {
            return {

                loading: false,
                chargeTime:'',
                editForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    institutionFeeCode:"",
                    name:'',
                    price:'',
                    status:''
                },
                statusValue:[
                    {
                        value: 1,
                        label: '正常'
                    },
                    {
                        value: 2,
                        label: '废弃'
                    }
                ],
                rules:{
                    price:[
                        { required: true, message: '请输入金额', trigger: 'blur' },
                        {
                            pattern: /^([0-9]?)+(\.[0-9][0-9]?)?$/,
                            message: "小数点后最多只能输入两位", trigger: 'blur'
                        }
                    ],
                    name:[
                        { required: true, message: '请输入费用名称', trigger: 'blur' },
                    ],
                    status:[
                        { required: true, message: '请选择状态', trigger: 'blur' },
                    ],
                }
            }
        },

        methods: {
            init(row){
                this.chargeTime = getChargeTime();
                if(getChargeTime()=='天'){
                    this.editForm.price = row.price;
                }else{
                    this.editForm.price = row.priceMonth;
                }
                this.editForm.name = row.name;
                this.editForm.status = row.status;
                this.editForm.institutionFeeCode = row.institutionFeeCode;
                
            },
            closeSelf() {
                this.$emit("closeEdit");
            },

            confirm(editForm){
                this.$refs[editForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })

            },

            addSubmit(){

               
                this.loading = true;

                this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"InstitutionFee/Edit",
                    data: this.editForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeEdit");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },


        }
    }


</script>





<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:  0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 730px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                height: 100%;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
